import { HotelInfoModel } from '@/__generated';
import HotelDetailMap from '@/components/HotelsMap/HotelDetailMap';
import { HOTEL_CONFIG } from '@/config';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  hotelInfo: HotelInfoModel;
};

export default function HotelLocation({ hotelInfo }: Props) {
  const [displayMap, setDisplayMap] = React.useState<boolean>(false);

  const parkingInfo = React.useMemo(() => {
    if (hotelInfo.hasParkingLot) {
      return [
        'Available',
        hotelInfo.parkingFee ? 'With Charge' : 'Free of Charge',
        `${hotelInfo.noOfParkingLot} cars`,
        hotelInfo.parkingHeightRestriction ? 'Height Limit' : '',
      ].join('. ');
    }
    return '';
  }, [hotelInfo]);
  return (
    <div className="px-30 py-30 border-light rounded-4">
      <div className="mb-15">
        <div
          className="flex-center"
          style={{
            backgroundImage: `url(${HOTEL_CONFIG.mapSvgThumbnail})`,
            height: '180px',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundColor: '#f0f8ff',
          }}
        >
          {hotelInfo.latitude && hotelInfo.longitude ? (
            <button
              className="button py-15 px-24 -blue-1 bg-white text-dark-1 absolute"
              onClick={() => {
                setDisplayMap(true);
              }}
            >
              <i className="icon-destination text-22 mr-10" />
              Show on map
            </button>
          ) : null}
        </div>
      </div>
      {/* End map */}
      {displayMap ? (
        <HotelDetailMap
          hotelInfo={hotelInfo}
          onClose={() => {
            setDisplayMap(false);
          }}
        />
      ) : null}

      <div className="row y-gap-10">
        <div className="col-12">
          <div className="d-flex items-center">
            <i className="icon-award text-20 text-blue-1" />
            <div className="text-14 fw-500 ml-20">{hotelInfo.access}</div>
          </div>
        </div>
        <div className="col-12">
          <div className="d-flex items-center">
            <i className="icon-location-2 text-20 text-blue-1" />
            <div className="text-14 fw-500 ml-20">{hotelInfo.address}</div>
          </div>
        </div>

        <div className="col-12">
          <div className="d-flex items-center">
            <i className="icon-parking text-20 text-blue-1" />
            {parkingInfo ? (
              <div className="text-14 fw-500 ml-20">{parkingInfo}</div>
            ) : (
              <div className="text-14 text-red-1 fw-500 ml-20">
                <FontAwesomeIcon icon={faBan} className="mr-5" />
                Not available
              </div>
            )}
          </div>
        </div>
      </div>
      {/* End .row */}

      <div className="border-top-light mt-15 mb-15" />
      <div className="text-15 fw-500">Hotel information</div>

      <div className="d-flex justify-between pt-10 ">
        <div className="text-14 ">
          <i className="ficon  ficon-express-check-in-check-out text-16 mr-5"></i> Check-in
        </div>
        <div className="text-14 fw-500">{hotelInfo.checkinTime}</div>
      </div>
      <div className="d-flex justify-between pt-10 ">
        <div className="text-14 ">
          <i className="ficon  ficon-express-check-in-check-out text-16 mr-5"></i> Check-out
        </div>
        <div className="text-14 fw-500">{hotelInfo.checkoutTime}</div>
      </div>

      {hotelInfo.phoneNumber ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon  ficon-telephone text-16 mr-5"></i> Tel
          </div>
          <div className="text-14 fw-500">{hotelInfo.phoneNumber}</div>
        </div>
      ) : null}

      {hotelInfo.faxNumber ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon  ficon-fax-machine text-16 mr-5"></i> Fax
          </div>
          <div className="text-14 fw-500">{hotelInfo.faxNumber}</div>
        </div>
      ) : null}

      {hotelInfo.capacity ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon ficon-regular-capacity text-16 mr-5"></i> Capacity
          </div>
          <div className="text-14 fw-500">{hotelInfo.capacity} people</div>
        </div>
      ) : null}

      {hotelInfo.noOfRooms ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon  ficon-number-of-rooms text-16 mr-5"></i> Guest rooms
          </div>
          <div className="text-14 fw-500">{hotelInfo.noOfRooms} rooms</div>
        </div>
      ) : null}
      {hotelInfo.transferCategory ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon  ficon-transfer-both-ways text-16 mr-5"></i> Meeting and sending off
          </div>
          <div className="text-14 fw-500">{hotelInfo.transferCategory}</div>
        </div>
      ) : null}
      {hotelInfo.hotelBuildings?.length ? (
        <div className="d-flex justify-between pt-10 ">
          <div className="text-14 ">
            <i className="ficon  ficon-pin-heart-of-city-building text-16 mr-5"></i> No of buildings
          </div>
          <div className="text-14 fw-500">{hotelInfo.hotelBuildings.length}</div>
        </div>
      ) : null}
    </div>
  );
}
